/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PaymentUpdateMutation($input: [PaymentUpdateInput!]!) {
  PaymentUpdate(input: $input) {
    id
    message
    status
  }
}
`
